import { OPTIONS, OPTIONS_INTEGRATION } from 'app-constants'
import { http } from 'hooks'

export function productService() {
  function getIsUserEligibleToBuy(params) {
    return http.get('/v1/products/change/eligibility', { params, ...OPTIONS_INTEGRATION })
  }

  function getBanners(contractId) {
    return http.get('/v1/products/recommendation/banners', {
      params: {
        contractId,
      },
      ...OPTIONS_INTEGRATION,
    })
  }

  function getProductRecommendations(contractId) {
    return http.get('v1/products/recommendation', {
      params: {
        contractId,
      },
      ...OPTIONS_INTEGRATION,
    })
  }

  function confirmSubscription(contractId, productsIds, token) {
    return http.post(
      '/v2/contracts/products/subscribe',
      { contractId, productsIds, token },
      OPTIONS_INTEGRATION
    )
  }

  function getFidelityUpgradePlan(contractId) {
    return http.get('/v1/contracts/available-plans', {
      params: {
        contractId,
      },
      ...OPTIONS_INTEGRATION,
    })
  }

  function confirmPlanUpgrade(body) {
    return http.post('/v1/contracts/plan-upgrade-confirmation', body, OPTIONS_INTEGRATION)
  }

  function activateHero(idContract) {
    return http.post(`/v1/contracts/${idContract}/hero/activate`, {}, OPTIONS)
  }

  return {
    getIsUserEligibleToBuy,
    getBanners,
    getProductRecommendations,
    confirmSubscription,
    getFidelityUpgradePlan,
    confirmPlanUpgrade,
    activateHero,
  }
}
